import { faCircle, faCircleCheck, faCircleDot, faCircleExclamation, faOctagonXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import * as style from './style.module.css';

export const InputRadio = ({ name = '', checked = false, onChange = () => {}, onBlur = () => {}, onFocus = () => {}, mode = 'normal' }) => {
    const getIcon = () => {
        if (mode === 'normal') {
            return checked ? faCircleDot : faCircle;
        }
        if (mode === 'correct') {
            return faCircleCheck;
        }
        if (mode === 'error') {
            return faOctagonXmark;
        }
        if (mode === 'warning') {
            return faCircleExclamation;
        }
        return faCircle;
    };

    return (
        <label>
            <input
                type="radio"
                name={name}
                checked={checked}
                className={style.input}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
            />
            <div className={style.iconcontainer}>
                <FontAwesomeIcon className={`${style[mode]} ${checked ? style.selected : ''}`} icon={getIcon()} />
            </div>
        </label>
    );
};
